import { Typography } from '@mui/material';
import React from 'react';

const CardBodyComponent = ({ content }: { content: React.ReactNode }) => {
  return (
    <Typography data-testid="card-body" sx={{ marginBottom: '1em' }}>
      {content}
    </Typography>
  );
};

export default CardBodyComponent;
